import { toast } from "@assetwatch/ui";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  type MotionAmplificationJobId,
  retryMotionAmplificationJob,
} from "../clients/motion-amplification";
import i18n from "../i18n/config";
import { motionAmplificationJobsListKey } from "../queries/useMotionAmplificationJobsQuery";

export function useRetryMotionAmplificationJobMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["motion-amplification", "retry"],
    mutationFn: (jobId: MotionAmplificationJobId) =>
      retryMotionAmplificationJob(jobId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: motionAmplificationJobsListKey,
      });
      toast.add(i18n.t("motionAmplification.retrySuccess"));
    },
    onError: (error) => {
      toast.error(
        error instanceof Error
          ? error.message
          : i18n.t("motionAmplification.retryError"),
      );
    },
  });
}
